import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import { Box, IconButton, Popover } from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import { permissionsSelector } from "../../store/state/user/selectors";
import PortalList from "./PortalList";
import { shouldShowPortalSwitcher } from "./portalSwitcherHelper";

const PortalSwitcherButton = () => {
  const permissions = useSelector(permissionsSelector);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  if (!shouldShowPortalSwitcher(permissions)) {
    return null;
  }

  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <IconButton onClick={(e) => setAnchorEl(e.currentTarget)} aria-label="Switch portal">
        <MenuRoundedIcon />
      </IconButton>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <Box sx={{ minWidth: 280, py: 1 }}>
          <PortalList onNavigate={handleClose} subheader="Portals" />
        </Box>
      </Popover>
    </>
  );
};

export default PortalSwitcherButton;
